// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 通用按钮样式 */
button {
  cursor: pointer;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background-color 0.3s, color 0.3s;
}

/* 卡片容器样式 */
.card {
  width: 18rem;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* 卡片内容容器样式，使用 flex 布局来排列子元素 */
.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 15px;
  flex-grow: 1;
}

/* 卡片标题样式 */
.card-title {
  font-size: 20px;
  margin-bottom: 10px;
}

/* 链接样式 */
.card-title a {
  text-decoration: none;
  color: #333;
}

.card-title a:hover {
  text-decoration: underline;
}

/* 链接样式 */
.card-link {
  text-decoration: none;
  color: #007bff;
  font-weight: bold;
  cursor: pointer;
}

.card-link:hover {
  text-decoration: underline;
}

/* 时间样式 */
.timer {
  font-size: 10px;
  color: #007bff;
  margin-left: 5px;
}

.task-nums-container {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}

.clear-button {
  height: 36px;
  text-align: center;
  border: 1px solid #696969; /* 设置边框为黑色 */
  background-color: #ededed; /* 设置背景为灰色 */
  border-radius: 0.6rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0.5rem;
  color: #696969; /* 设置字体颜色和边框颜色相同 */
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1;
}

.clear-button:disabled {
  background-color: #f7f7f7; /* 设置禁用状态的背景颜色 */
  border-color: #dbdbdb; /* 设置禁用状态的边框颜色 */
  color: #dbdbdb; /* 设置禁用状态的字体颜色 */
}

/* X 按钮样式，绝对定位在右上角 */
.top-right {
  position: absolute;
  top: 0;
  right: 0;
}

/* .bottom-left {
  position: absolute;
  bottom: 0;
  left: 0;
} */

.import-button {
  margin-bottom: 1rem;
}

.export-button {
  margin-bottom: 1rem;
}

.etl-button,
.config-button {
  width: auto; /* 移除按钮的固定宽度 */
}

.lb-etl-button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 75%;
  margin-top: auto; /* 将按钮容器推到卡片底部 */
  margin-bottom: 2rem;
}

.config-button,
.etl-button {
  flex: 1 1; /* 让按钮平均分配宽度 */
  margin-right: 8px; /* 为按钮之间添加间距 */
}

.projectGallery {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start; /* 靠左排列 */
  align-items: flex-start;    /* 顶部对齐 */
}

.label-studio-main {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.label-studio-projects {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.annotation-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
}

.annotation-org-chip {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 38px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}

.annotation-org-chip span {
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.annotation-org-chip strong {
  color: #0f172a;
  font-size: 13px;
}

.annotation-primary-action {
  min-height: 38px;
  border: 1px solid #2563eb !important;
  border-radius: 10px !important;
  background: #2563eb !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  box-shadow: none !important;
}

.label-studio-projects .projectGallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
  width: 100%;
}

.label-studio-projects .label-studio-project-card {
  position: relative;
  width: auto !important;
  min-width: 0;
  min-height: 100%;
  margin: 0;
  padding: 18px;
  border: 1px solid #e6edf7;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.04);
  align-items: stretch;
  text-align: left;
  overflow: hidden;
}

.label-studio-projects .label-studio-project-card:hover {
  transform: none;
  border-color: #bfdbfe;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
}

.label-studio-projects .card-content {
  align-items: stretch;
  padding: 0;
  text-align: left;
}

.project-open-button {
  align-items: flex-start;
  width: 100%;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  text-align: left;
}

.annotation-card-kicker {
  display: block;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.label-studio-projects .card-title {
  margin: 3px 0 10px;
  color: #0f172a;
  font-size: 17px;
  font-weight: 800;
}

.label-studio-projects a {
  color: #2563eb !important;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none !important;
}

.annotation-meta-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 14px 0 12px;
}

.annotation-meta-grid div {
  min-width: 0;
  padding: 9px;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  background: #f8fafc;
}

.annotation-meta-grid span {
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.annotation-meta-grid strong {
  display: block;
  margin-top: 3px;
  color: #0f172a;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.annotation-card-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid #eef2f7;
}

.annotation-card-actions .org-btn,
.annotation-toolbar .org-btn,
.label-studio-customized-content .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}

.annotation-toolbar .org-btn {
  width: auto;
  min-width: 140px;
  white-space: nowrap;
}

.label-studio-projects .top-right {
  top: 12px;
  right: 12px;
  opacity: 0.55;
  transition: background 160ms ease, opacity 160ms ease;
}

.label-studio-projects .label-studio-project-card:hover .top-right {
  opacity: 0.85;
}

.label-studio-projects .top-right:hover {
  background: #fde8e8;
  opacity: 1;
}

.label-studio-customized-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.label-studio-customized-content .org-btn,
.label-studio-upload-input .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}

.label-studio-project-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.annotation-empty-state {
  grid-column: 1 / -1;
  padding: 36px;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  background: #f8fafc;
  color: #64748b;
  text-align: center;
  font-weight: 700;
}

@media (max-width: 600px) {
  .label-studio-projects .projectGallery,
  .annotation-meta-grid {
    grid-template-columns: 1fr;
  }

  .annotation-org-chip,
  .annotation-toolbar .org-btn {
    width: 100%;
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LabelStudioProject/LabelStudioProject.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA,WAAW;AACX;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,YAAY;EACvC,yBAAyB,EAAE,YAAY;EACvC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc,EAAE,kBAAkB;EAClC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,qBAAqB,EAAE,gBAAgB;EACvC,cAAc,EAAE,gBAAgB;AAClC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;;;;GAIG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW,EAAE,cAAc;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,gBAAgB,EAAE,gBAAgB;EAClC,mBAAmB;AACrB;;AAEA;;EAEE,SAAO,EAAE,cAAc;EACvB,iBAAiB,EAAE,cAAc;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B,EAAE,SAAS;EACtC,uBAAuB,KAAK,SAAS;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* 通用按钮样式 */\nbutton {\n  cursor: pointer;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 5px;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n/* 卡片容器样式 */\n.card {\n  width: 18rem;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  margin: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n/* 卡片内容容器样式，使用 flex 布局来排列子元素 */\n.card-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 15px;\n  flex-grow: 1;\n}\n\n/* 卡片标题样式 */\n.card-title {\n  font-size: 20px;\n  margin-bottom: 10px;\n}\n\n/* 链接样式 */\n.card-title a {\n  text-decoration: none;\n  color: #333;\n}\n\n.card-title a:hover {\n  text-decoration: underline;\n}\n\n/* 链接样式 */\n.card-link {\n  text-decoration: none;\n  color: #007bff;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.card-link:hover {\n  text-decoration: underline;\n}\n\n/* 时间样式 */\n.timer {\n  font-size: 10px;\n  color: #007bff;\n  margin-left: 5px;\n}\n\n.task-nums-container {\n  display: flex;\n  flex-direction: row;\n  margin-top: 10px;\n}\n\n.clear-button {\n  height: 36px;\n  text-align: center;\n  border: 1px solid #696969; /* 设置边框为黑色 */\n  background-color: #ededed; /* 设置背景为灰色 */\n  border-radius: 0.6rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 0.5rem;\n  color: #696969; /* 设置字体颜色和边框颜色相同 */\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.clear-button:disabled {\n  background-color: #f7f7f7; /* 设置禁用状态的背景颜色 */\n  border-color: #dbdbdb; /* 设置禁用状态的边框颜色 */\n  color: #dbdbdb; /* 设置禁用状态的字体颜色 */\n}\n\n/* X 按钮样式，绝对定位在右上角 */\n.top-right {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n/* .bottom-left {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n} */\n\n.import-button {\n  margin-bottom: 1rem;\n}\n\n.export-button {\n  margin-bottom: 1rem;\n}\n\n.etl-button,\n.config-button {\n  width: auto; /* 移除按钮的固定宽度 */\n}\n\n.lb-etl-button-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 75%;\n  margin-top: auto; /* 将按钮容器推到卡片底部 */\n  margin-bottom: 2rem;\n}\n\n.config-button,\n.etl-button {\n  flex: 1; /* 让按钮平均分配宽度 */\n  margin-right: 8px; /* 为按钮之间添加间距 */\n}\n\n.projectGallery {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start; /* 靠左排列 */\n  align-items: flex-start;    /* 顶部对齐 */\n}\n\n.label-studio-main {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.label-studio-projects {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.annotation-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);\n}\n\n.annotation-org-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 38px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.annotation-org-chip span {\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.annotation-org-chip strong {\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.annotation-primary-action {\n  min-height: 38px;\n  border: 1px solid #2563eb !important;\n  border-radius: 10px !important;\n  background: #2563eb !important;\n  color: #ffffff !important;\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  box-shadow: none !important;\n}\n\n.label-studio-projects .projectGallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 14px;\n  width: 100%;\n}\n\n.label-studio-projects .label-studio-project-card {\n  position: relative;\n  width: auto !important;\n  min-width: 0;\n  min-height: 100%;\n  margin: 0;\n  padding: 18px;\n  border: 1px solid #e6edf7;\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.04);\n  align-items: stretch;\n  text-align: left;\n  overflow: hidden;\n}\n\n.label-studio-projects .label-studio-project-card:hover {\n  transform: none;\n  border-color: #bfdbfe;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);\n}\n\n.label-studio-projects .card-content {\n  align-items: stretch;\n  padding: 0;\n  text-align: left;\n}\n\n.project-open-button {\n  align-items: flex-start;\n  width: 100%;\n  padding: 0 !important;\n  border: 0 !important;\n  background: transparent !important;\n  text-align: left;\n}\n\n.annotation-card-kicker {\n  display: block;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.label-studio-projects .card-title {\n  margin: 3px 0 10px;\n  color: #0f172a;\n  font-size: 17px;\n  font-weight: 800;\n}\n\n.label-studio-projects a {\n  color: #2563eb !important;\n  font-size: 13px;\n  font-weight: 800;\n  text-decoration: none !important;\n}\n\n.annotation-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin: 14px 0 12px;\n}\n\n.annotation-meta-grid div {\n  min-width: 0;\n  padding: 9px;\n  border: 1px solid #eef2f7;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.annotation-meta-grid span {\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.annotation-meta-grid strong {\n  display: block;\n  margin-top: 3px;\n  color: #0f172a;\n  font-size: 13px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.annotation-card-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 12px;\n  border-top: 1px solid #eef2f7;\n}\n\n.annotation-card-actions .org-btn,\n.annotation-toolbar .org-btn,\n.label-studio-customized-content .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n\n.annotation-toolbar .org-btn {\n  width: auto;\n  min-width: 140px;\n  white-space: nowrap;\n}\n\n.label-studio-projects .top-right {\n  top: 12px;\n  right: 12px;\n  opacity: 0.55;\n  transition: background 160ms ease, opacity 160ms ease;\n}\n\n.label-studio-projects .label-studio-project-card:hover .top-right {\n  opacity: 0.85;\n}\n\n.label-studio-projects .top-right:hover {\n  background: #fde8e8;\n  opacity: 1;\n}\n\n.label-studio-customized-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.label-studio-customized-content .org-btn,\n.label-studio-upload-input .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n\n.label-studio-project-info {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.annotation-empty-state {\n  grid-column: 1 / -1;\n  padding: 36px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 16px;\n  background: #f8fafc;\n  color: #64748b;\n  text-align: center;\n  font-weight: 700;\n}\n\n@media (max-width: 600px) {\n  .label-studio-projects .projectGallery,\n  .annotation-meta-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .annotation-org-chip,\n  .annotation-toolbar .org-btn {\n    width: 100%;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
